import { ExchangeService } from "../common/services/exchange.service";

class cashBalanceDialogController {
  cashAccounts: any[];
  buySellDetails: { [currency: string]: number };

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService, private exchangeService: ExchangeService) { }

  convertFromMUR(value: number, currency: string) {
    if (!value) return 0;

    return this.exchangeService.convertFromMUR(value, currency);
  }

  convertToMUR(value: number, currency: string) {
    if (!value) return 0;

    return this.exchangeService.convertToMUR(value, currency);
  }

  closeDialog() {
    this.$mdDialog.hide();
  }
}

export const cashBalanceDialog: angular.IComponentOptions = {
  controller: cashBalanceDialogController,
  template: require('./cashBalance.dialog.html'),
  bindings: {
    cashAccounts: '<',
    buySellDetails: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/simulations/cashBalance.dialog.ts